import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import LogoLink from '../Components/Common/LogoLink';
import StaggeredMenu from '../Components/Layout/StaggeredMenu';
import './Home.css'
import SectionLabel from '../Components/Common/SectionLabel';
import HeroText from '../Components/Common/HeroText';
import Btn from '../Components/Common/Btn';
import AboutCard from '../Components/Layout/AboutCard';
import PlanScroller from '../Components/Layout/PlanScroller';
import ScrollStack, { ScrollStackItem } from '../Components/Layout/ScrollStack'

import Range from '../Assets/Icons/Range.svg';
import Hp from '../Assets/Icons/HP.svg';
import Speed from '../Assets/Icons/SPeed.svg';
import Vw from '../Assets/Imgs/VW.png';
import Audi from '../Assets/Imgs/Audi.png';
import Link from '../Assets/Imgs/Link.png';
import Kia from '../Assets/Imgs/Kia.png';
import ScrollVelocity from '../Components/Common/ScrollVelocity';


import PartnerLogo from '../Components/Common/PartnerLogo';
import Footer from '../Components/Layout/Footer';

import { supabase } from './../supabase';


gsap.registerPlugin(ScrollTrigger);

const Home = () => {


    //card animation
    const [cardClass, setCardClass] = useState("AboutCard");



    //hero scroll
    const canvasRef = useRef(null);
    const containerRef = useRef(null);
    

    const frameCount = 60; 
    const images = useRef([]);
    const FrameObject = useRef({ frame: 0 });

    useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");


    const currentFrame = (index) => 
        `/sequence/HeroCar${(index + 1).toString().padStart(4, '0')}.png`;

    const preloadImages = () => {
        for (let i = 0; i < frameCount; i++) {
            const img = new Image();
            img.src = currentFrame(i);
            images.current[i] = img;
        }
    };

    const render = () => {
        const img = images.current[FrameObject.current.frame];
        // The check to prevent the 'broken state' error
        if (img && img.complete && img.naturalWidth !== 0) {
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(img, 0, 0, canvas.width, canvas.height);
        }
    };

    preloadImages();

    const scrollAnim = gsap.to(FrameObject.current, {
        frame: frameCount - 1,
        snap: "frame",
        ease: "none",
        scrollTrigger: {
            trigger: containerRef.current,
            start: "top top",
            end: "bottom bottom",
            scrub: 0.5,
            onUpdate: render,
        }
    });

    images.current[0].onload = render;

    return () => {
        scrollAnim.kill();
        ScrollTrigger.getAll().forEach(t => t.kill());
    };
}, [frameCount]);

    const menuItems = [
        { label: 'Home', ariaLabel: 'Go to home page', link: '/' },
        { label: 'Booking', ariaLabel: 'Book your visit', link: '/booking' },
        { label: 'Gallery', ariaLabel: 'Take a peek at our past events', link: '/gallery' }
      ];


      // ------------------------------------------------------------------------------------------------------------------------------- //


      //supabase fucntions

      const [content, setContent] = useState({});
      const [loading, setLoading] = useState(true);
      const [fleet, setFleet] = useState([]);

      useEffect(() => {
        const fetchContent = async () => {
            const { data, error } = await supabase
                .from('siteContent')
                .select('content_key, content_value')
                .eq('page_name', 'landing');

            if (!error && data) {
                const contentMap = data.reduce((acc, item) => {
                    acc[item.content_key] = item.content_value;
                    return acc;
                }, {});
                setContent(contentMap);
            }
            setLoading(false);
        };

        fetchContent();
    }, []);

    useEffect(() => {
        const fetchHomeData = async () => {
            const contentRes = await supabase.from('siteContent').select('*').eq('page_name', 'landing');
            if (contentRes.data) {
                const contentMap = contentRes.data.reduce((acc, item) => {
                    acc[item.content_key] = item.content_value;
                    return acc;
                }, {});
                setContent(contentMap);
            }

            const fleetRes = await supabase.from('fleet').select('*');
            if (fleetRes.data) {
                setFleet(fleetRes.data);
            }
            
            setLoading(false);
        };

        fetchHomeData();
    }, []);



    return ( <>
        <div>
        <StaggeredMenu
            position="right"
            items={menuItems}
            displaySocials
            displayItemNumbering={true}
            menuButtonColor="#3A3A3A"
            openMenuButtonColor="#3A3A3A"
            changeMenuColorOnOpen={true}
            colors={['#35A44F', '#21FF55']}
            logoUrl='../Assets/Imgs/Logo.svg'
            accentColor="#35A44F"
            onMenuOpen={() => console.log('Menu opened')}
            onMenuClose={() => console.log('Menu closed')}
        />
        </div>

        <main>
            <div className='TopContainer'>
                <div className='TopSections' ref={containerRef}>
                        <div className='ModelContainer'>
                            <div className='ModelSticky'>
                                <div className='Model'>
                                    <canvas 
                                        ref={canvasRef} 
                                        width={1920} 
                                        height={1080} 
                                        className='HeroVid'
                                    />
                                </div>
                            </div>
                        </div>
                    <section className='Hero'>
                        <div className="HeroContent">
                        <div className='GreenStrip1'></div>
                        <div className='GreenStrip2'></div>
                            <LogoLink />

                            <div className='HeroText'>
                                <SectionLabel SectionLabel={content.hero_label}/>
                                <p className='HeroTitle'>
                                   {content.hero_title ? content.hero_title.split(' ')[0] : "The Future is"} <span className='green'>
                                        <HeroText
                                        text="Electric"
                                        flex
                                        alpha={false}
                                        stroke={false}
                                        width
                                        weight
                                        italic
                                        textColor="#35A44F"
                                        strokeColor="#5227FF"
                                        minFontSize={64}
                                    /></span>                                           
                                </p>
                                <p className='HeroSub'>
                                    {content.hero_subtitle}
                                </p>
                                <Btn className="HeroBtn" BtnText="Register Now" BtnPath="/booking"/>
                            </div>
                        </div>
                    </section>
                    
                    <section className='About' id='AboutSec' onMouseEnter={() => setCardClass("AboutCard AboutCardAnim")}>
                        <AboutCard ACardStyle={cardClass} AboutTitle={content.about_title} AboutP={content.about_description}/>
                    </section> 
                </div>
            </div>
            

            <PlanScroller />

            <section className='Showroom'>
                <SectionLabel SectionLabel={content.showroom_label} />
                <p className='SectionTitle'>
                    {content.showroom_title}
                </p>

                <div className='ShowroomCards'>
                    <ScrollStack>
                        {fleet.map((car) => (
                            <ScrollStackItem key={car.id} itemClassName="ScrollCards">
                                <div className='CardText'>
                                    <p className='SectionTitle'>{car.car_name}</p>

                                    <div className='CarStats'>
                                        <div className='StatIcons'>
                                            <div className='StatGroup'>
                                                <img className='StatIcon' src={Range} alt="Range" />
                                                <p className='StatNum'>{car.range}</p>
                                                <p className='StatTitle'>Range</p>
                                            </div>
                                            <div className='StatGroup'>
                                                <img className='StatIcon' src={Hp} alt="Horsepower" />
                                                <p className='StatNum'>{car.hp}</p>
                                                <p className='StatTitle'>Horsepower</p>
                                            </div>
                                            <div className='StatGroup'>
                                                <img className='StatIcon' src={Speed} alt="Top Speed" />
                                                <p className='StatNum'>{car.top_speed}</p>
                                                <p className='StatTitle'>Top Speed</p>
                                            </div>
                                        </div>
                                    </div>

                                    <Btn BtnText="Learn More" className="CardBtn" BtnPath="/Booking" />
                                </div>

                                <img className='CardImg' src={car.car_img} alt={car.car_name} />
                            </ScrollStackItem>
                        ))}
                    </ScrollStack>
                </div>
            </section>

            <section className='Partners'>
                <SectionLabel SectionLabel={content.partners_label}/>
                <p className='SectionTitle'>
                    {content.partners_title}
                </p>

                <div className='PartnerLogos'>
                    <ScrollVelocity
                    texts={[<PartnerLogo className="PartnerLogo"/> , <PartnerLogo className="PartnerLogoInvert"/>]} 
                    velocity={100}
                    className="custom-scroll-text"
                    numCopies={6}
                    damping={50}
                    stiffness={400}
                    />
                </div>
            </section>

        </main>

        <Footer/>
    </> );
}

export default Home;